import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aujdasturxpqlzqjbztf.supabase.co'; 
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1amRhc3R1cnhwcWx6cWpienRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA2OTE4NTcsImV4cCI6MjA2NjI2Nzg1N30.dSOWJvB0yLMC6Xv5SRTI2R-_GV_9efxyDXB82R6bMdg'; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
